var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "conversation-row d-flex align-center py-1 pr-2",
      class: {
        "conversation-row--active": _vm.selected,
        "conversation-row--limpo": _vm.estiloLimpo,
        "conversation-row--batch-selected": _vm.selectedForBatch
      },
      attrs: { draggable: !_vm.editing },
      on: {
        click: function($event) {
          return _vm.handleSelect($event)
        },
        dragstart: _vm.onDragStart
      }
    },
    [
      !_vm.semIcone && !_vm.estiloLimpo
        ? _c("icon-svg", {
            staticClass: "conversation-row__icon mr-2 flex-shrink-0",
            attrs: { name: "message", size: 14, color: "#8E8E8E" }
          })
        : _vm._e(),
      _vm.editing
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editingTopic,
                expression: "editingTopic"
              }
            ],
            ref: "renameInput",
            staticClass:
              "conversation-row__rename az-ds-body flex-grow-1 py-0 px-1",
            attrs: { maxlength: "100", "aria-label": "Renomear conversa" },
            domProps: { value: _vm.editingTopic },
            on: {
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.saveEdit($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.cancelEdit($event)
                }
              ],
              blur: _vm.saveEdit,
              click: function($event) {
                $event.stopPropagation()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.editingTopic = $event.target.value
              }
            }
          })
        : _c(
            "div",
            {
              staticClass:
                "conversation-row__info d-flex align-center flex-grow-1"
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "conversation-row__label ia-texto-auxiliar az-ds-body text-truncate",
                  attrs: { title: _vm.topicLabel },
                  on: {
                    dblclick: function($event) {
                      $event.stopPropagation()
                      return _vm.startEdit($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.topicLabel))]
              ),
              _vm.mostrarAgente && _vm.agenteLabel
                ? _c(
                    "span",
                    { staticClass: "conversation-row__agente ia-texto-micro" },
                    [_vm._v(_vm._s(_vm.agenteLabel))]
                  )
                : _vm._e(),
              _c(
                "span",
                {
                  staticClass: "conversation-row__date az-ds-aux text-truncate"
                },
                [_vm._v(_vm._s(_vm.metaLabel))]
              )
            ]
          ),
      !_vm.editing
        ? [
            _c(
              "div",
              {
                staticClass: "conversation-row__menu flex-shrink-0",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _c(
                  "BaseActionsMenu",
                  {
                    attrs: {
                      "icon-only": "",
                      label: "Ações da conversa",
                      actions: _vm.rowActions
                    }
                  },
                  [
                    _c("div", { staticClass: "conversation-row__menu-slot" }, [
                      _vm.mostrarMoverParaPasta
                        ? _c(
                            "button",
                            {
                              ref: "moveTrigger",
                              staticClass:
                                "conversation-row__menu-item ia-texto-corpo",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleMoveFlyout($event)
                                },
                                mouseenter: _vm.openMoveFlyout,
                                mouseleave: _vm.scheduleCloseMoveFlyout
                              }
                            },
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: "folder-outline",
                                  size: 15,
                                  color: "#8E8E8E"
                                }
                              }),
                              _c("span", { staticClass: "flex-grow-1" }, [
                                _vm._v("Mover para pasta")
                              ]),
                              _c("icon-svg", {
                                attrs: {
                                  name: "mdi-chevron-right",
                                  size: 16,
                                  color: "#8E8E8E"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.mostrarRemoverDaPasta
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "conversation-row__menu-item ia-texto-corpo",
                              attrs: { type: "button" },
                              on: { click: _vm.removeFromFolder }
                            },
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: "close",
                                  size: 15,
                                  color: "#8E8E8E"
                                }
                              }),
                              _c("span", [_vm._v("Remover da pasta")])
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "button",
                        {
                          staticClass:
                            "conversation-row__menu-item ia-texto-corpo conversation-row__menu-item--danger",
                          attrs: { type: "button" },
                          on: { click: _vm.requestDelete }
                        },
                        [
                          _c("icon-svg", {
                            attrs: { name: "trash", size: 15, color: "danger" }
                          }),
                          _c("span", [_vm._v("Remover")])
                        ],
                        1
                      )
                    ])
                  ]
                )
              ],
              1
            ),
            _vm.moveFlyoutOpen
              ? _c(
                  "div",
                  {
                    ref: "moveFlyout",
                    staticClass: "conversation-row__flyout",
                    style: _vm.moveFlyoutStyle,
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      },
                      mouseenter: _vm.clearMoveFlyoutCloseTimer,
                      mouseleave: _vm.scheduleCloseMoveFlyout
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "conversation-row__flyout-title az-ds-label d-block pt-1 pb-1 px-3"
                      },
                      [_vm._v(" Mover para pasta ")]
                    ),
                    _vm._l(_vm.folderPickerItems, function(opt) {
                      return _c(
                        "button",
                        {
                          key: opt.key,
                          staticClass:
                            "conversation-row__move-item az-ds-body d-flex align-center az-gap-small py-2 px-3",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.pickFolder(opt)
                            }
                          }
                        },
                        [
                          opt.color
                            ? _c("span", {
                                staticClass:
                                  "conversation-row__swatch flex-shrink-0",
                                style: { backgroundColor: opt.color }
                              })
                            : _c("icon-svg", {
                                staticClass:
                                  "conversation-row__swatch-icon flex-shrink-0",
                                attrs: {
                                  name: "close",
                                  size: 13,
                                  color: "#8E8E8E"
                                }
                              }),
                          _c("span", { staticClass: "text-truncate" }, [
                            _vm._v(_vm._s(opt.label))
                          ])
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }